import { useLocalStorage } from "usehooks-ts";

import {
  INBOX_LIST_THREAD_LAYOUT,
  INBOX_LIST_THREAD_LAYOUT_STORAGE_KEY,
  type InboxListThreadLayout,
  isInboxListThreadLayout,
} from "./inbox-list-thread-layout";

/**
 * Whether the conversation list sits beside the selected thread or stacked above it.
 *
 * Stored as a string and narrowed on read so a corrupt value falls back to the default, the same
 * shape as the thread reading order preference. `useLocalStorage` broadcasts on write and every
 * instance listens, which is what lets Settings set this at all: `UserMenu` renders above the route
 * outlet that owns the inbox shell, so it cannot reach that state by props.
 */
export const useInboxListThreadLayout = () => {
  const [storedListThreadLayout, setStoredListThreadLayout] = useLocalStorage<string>(
    INBOX_LIST_THREAD_LAYOUT_STORAGE_KEY,
    INBOX_LIST_THREAD_LAYOUT.sideBySide
  );

  return {
    listThreadLayout: isInboxListThreadLayout(storedListThreadLayout)
      ? storedListThreadLayout
      : INBOX_LIST_THREAD_LAYOUT.sideBySide,
    setListThreadLayout: (layout: InboxListThreadLayout) => setStoredListThreadLayout(layout),
  };
};
